import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './i18n'
import App from './App.tsx'
import { initSentry } from './lib/sentry'
import { initAnalytics } from './lib/analytics'
import { attachInstallPromptListeners } from './lib/install/prompt-store'

initSentry()
initAnalytics()

// Chrome and Edge offer the install dialog once, early, and only to a listener
// that already exists, so it is caught here before the first render and held
// for the /install page and the home-screen card (src/lib/install).
attachInstallPromptListeners()

// The service worker carries web push (built from src/sw/sw.ts). Registering
// it never asks for permission; that happens on the Profile page, when the
// seeker turns notifications on for this device.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(err => {
      console.warn('[sw] registration failed:', err instanceof Error ? err.message : err)
    })
  })
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
